// 使用原生方式操作cookie，避免js-cookie依赖问题
function getCookieOptions() {
  return {
    path: '/',
    secure: location.protocol === 'https:',
    sameSite: 'Lax' as const,
    maxAge: 30 * 24 * 60 * 60, // 30天
  };
}

export function setCookie(name: string, value: string) {
  const options = getCookieOptions();
  let cookieString = `${name}=${encodeURIComponent(value)}`;

  if (options.path) cookieString += `; path=${options.path}`;
  if (options.maxAge) cookieString += `; max-age=${options.maxAge}`;
  if (options.secure) cookieString += '; secure';
  if (options.sameSite) cookieString += `; samesite=${options.sameSite}`;

  // biome-ignore lint/suspicious/noDocumentCookie: Legacy cookie setting method
  document.cookie = cookieString;
}

export function getCookie(name: string): string | undefined {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) {
    const cookieValue = parts.pop()?.split(';').shift();
    return cookieValue ? decodeURIComponent(cookieValue) : undefined;
  }
  return undefined;
}

export function removeCookie(name: string) {
  // biome-ignore lint/suspicious/noDocumentCookie: Legacy cookie removal method
  document.cookie = `${name}=; path=${getCookieOptions().path}; max-age=0`;
}

export function getToken(): string | undefined {
  return getCookie('admin_access_token');
}
